module.exports = __webpack_public_path__ + "static/1seater_4k-ed2b4761d13afef52473c8a9f43d8cc0.webp";